import { Table } from "components";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import type { TableAdapterProps } from "./Table.d";

const TableAdapter = ({
  blok: {
    content: { tbody: storyblokTbody, thead: storyblokThead },
  },
}: ReactStoryblokComponent<TableAdapterProps>) => {
  const thead = storyblokThead?.map(({ value, _uid }) => ({ id: _uid, value }));
  const tbody = storyblokTbody?.map(({ _uid: trId, body: tr }) => ({
    id: trId,
    td: tr.map(({ _uid: tdId, value }) => ({ id: tdId, value })),
  }));

  return <Table thead={thead} tbody={tbody} />;
};

export default TableAdapter;
